/* istanbul ignore next */
/**
 * Class representing the route helper.
 */
export class RouteHelper {
	/**
	 * Redirects to external url by changing the window.location
	 * @param {string} url
	 */
	static redirectToExternalUrl(url: string): void {
		window.location.href = url;
	}

	/**
	 * Redirects to external url by opening a new tab
	 * Note this does not work automatically inside an async process on safari
	 * To fix this: https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari#:~:text=Using-,setTimeout,-EDIT%3A%20A%20few
	 * Wrapping a settimeout around it, runs the code on the main thread instead of the async one.
	 * @param {string} url
	 */
	static redirectToExternalUrlInNewTab(url: string): void {
		window.open(url, '_blank');
	}

	/**
	 * Redirects to url by overwriting the current url in the history.
	 * @param {string} url
	 */
	static replaceLocation(url: string): void {
		window.location.replace(url);
	}

	/**
	 * Reloads the current page.
	 */
	static reloadPage(): void {
		window.location.reload();
	}
}
